import Swal from "sweetalert2";
import { toast as rtToast } from "react-toastify";

import { notificationTypeItems } from "..";

export const toastSuccessMessage = (message) => {
  Toast.fire({
    icon: "success",
    title: message,
  });
};

export const toastErrorMessage = (message) => {
  Toast.fire({
    icon: "error",
    title: message,
  });
};

export const toastWarningMessage = (message) => {
  Toast.fire({
    icon: "warning",
    title: message,
  });
};

export const notificationMessage = (
  title,
  message,
  type,
  isAutoClose = false,
  url
) => {
  // const body = `${title}-${message}`;
  const body = (
    <div style={{display: 'flex', flexDirection:'column'}}>
      <h5 className="mb-0">{title}</h5>
      {message && <p style={{fontFamily: 'primary-font'}}>{message}</p>}
    </div>
  );

  const closeOnClick = () => {
    window.location.href = url;
  };
  switch (type) {
    case notificationTypeItems[0]:
      rtToast.success(body, {
        autoClose: isAutoClose,
        ...(url && { closeOnClick }),
      });
      break;
    case notificationTypeItems[1]:
      rtToast.error(body, {
        autoClose: isAutoClose,
        ...(url && { closeOnClick }),
      });
      break;
    case notificationTypeItems[2]:
      rtToast.info(body, {
        autoClose: isAutoClose,
        ...(url && { closeOnClick }),
      });
      break;
    case notificationTypeItems[3]:
      rtToast.warning(body, {
        autoClose: isAutoClose,
        ...(url && { closeOnClick }),
      });
      break;

    default:
      break;
  }
};

export const deliverySuccessMessage = (message, redirectUrl) => {
  Swal.fire({
    icon: "success",
    html: `<h5> ${message} </h5>`,
    confirmButtonText: "تایید",
    onClose: () => {
      window.location.href = redirectUrl;
    },
  });
};

export const modalErrorMessage = (message, redirectUrl) => {
  Swal.fire({
    icon: "error",
    title: "خطا",
    html: message,
    confirmButtonText: "باشه",
    onClose: () => {
      if (redirectUrl) {
        window.location.href = redirectUrl;
      }
    },
  });
};

export const modalSuccessMessage = (message) => {
  Swal.fire({
    icon: "success",
    title: "عملیات موفق",
    html: message,
    confirmButtonText: "باشه",
  });
};

export const areYouSureMessage = (
  func = () => {},
  title = "آیا مطمئنید ؟",
  dismissFunc
) => {
  Swal.fire({
    title,
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#3085d6",
    cancelButtonColor: "#d33",
    confirmButtonText: "بله مطمئنم",
    cancelButtonText: "خیر",
  }).then((result) => {
    if (result.value) {
      func();
    }
    if (result.dismiss) {
      dismissFunc();
    }
  });
};

const Toast = Swal.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 5000,
  showCloseButton: true,
  timerProgressBar: true,
  onOpen: (toast) => {
    toast.addEventListener("mouseenter", Swal.stopTimer);
    toast.addEventListener("mouseleave", Swal.resumeTimer);
  },
});
